export const WORK_TYPE = [
  { label: "Online", value: 1 },
  { label: "Offline", value: 2 },
];

export const OFFLINE = 2;
export const ONLINE = 1;
export const ENTRANCE_EXAM_MARKING = 3;

export const ADMIN_PROFILE_TYPE = [
  { label: "Chấm thi đầu khóa", value: 3 },
  { label: "Coi thi", value: 0 },
  { label: "Chấm thi", value: 1 },
  { label: "Tất cả", value: 2 },

];

export const ADMIN_TYPE_VALUE = {
  MARKING: 0,
  ADMIN_TUTOR: 1,
  ADMIN_TEST_INPUT: 2,
};

export const Marking = 0;
export const Tutor = 1;
export const TestInput = 2;

export const TYPE_WORK_ONLINE = 1;
export const TYPE_WORK_OFFLINE = 2;
